import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  {
    path: '/',
    redirect: '/live'
  },
  {
    path: '/course',
    name: '部门数据',
    meta: {
      title: '部门数据'
    },
    component: () => import('../views/course/index.vue')
  },
  {
    path: '/course_detail',
    name: '数据详情',
    meta: {
      title: '数据详情'
    },
    component: () => import('../views/course/detail.vue')
  },
  {
    path: '/course_info',
    name: '数据明细',
    meta: {
      title: '数据明细'
    },
    component: () => import('../views/course/info.vue')
  },
  {
    path: '/course_list',
    name: '数据列表',
    meta: {
      title: '数据列表'
    },
    component: () => import('../views/course/list.vue')
  },
  {
    path: '/watch_index',
    name: 'watch_index',
    meta: {
      title: '缴费客户观看直播情况'
    },
    component: () => import('../views/course/watch_index.vue')
  },
  {
    path: '/watch_detail',
    name: 'watch_detail',
    meta: {
      title: '缴费客户观看直播明细'
    },
    component: () => import('../views/course/watch_detail.vue')
  },
  {
    path: '/watch_teacher',
    name: 'watch_teacher',
    meta: {
      title: '缴费客户观看老师明细'
    },
    component: () => import('../views/course/watch_teacher.vue')
  },
  {
    path: '/chat_records',
    name: 'chat_records',
    meta: {
      title: '用户聊天记录'
    },
    component: () => import('../views/course/chat_records.vue')
  },
  {
    path: '/live',
    name: 'live',
    meta: {
      title: '直播'
    },
    component: () => import('../views/live/index.vue')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})

export default router
